// frontend/src/components/LoadingSpinner.js

import React from 'react';

function LoadingSpinner() {
  return <div id="loading-spinner"></div>;
}

export default LoadingSpinner;
